module.exports = __webpack_public_path__ + "1d2ec6f627924cf1bcc8901ca04c5ac2.png";